module.exports = __webpack_public_path__ + "img/print-example-business-card.fb35bea8.png";